import script from "./DataSourceView.vue?vue&type=script&setup=true&lang=js"
export * from "./DataSourceView.vue?vue&type=script&setup=true&lang=js"

import "./DataSourceView.vue?vue&type=style&index=0&id=0e3936e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e3936e0"]])

export default __exports__